import { render, staticRenderFns } from "./DeleteDatasetDialog.vue?vue&type=template&id=2bdd8db6&scoped=true&"
import script from "./DeleteDatasetDialog.vue?vue&type=script&lang=js&"
export * from "./DeleteDatasetDialog.vue?vue&type=script&lang=js&"
import style0 from "./DeleteDatasetDialog.vue?vue&type=style&index=0&id=2bdd8db6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdd8db6",
  null
  
)

export default component.exports